import * as React from 'react';
import * as Moment from 'moment';
import { UserService } from '@fnv-core/authentication';
import { Tokenizer } from '@fnv-core/tokens';
import { FormState, FormProps, FormControllerContainer } from '../FormContainer';
import { ProcesHandlerHelpers, ProcesName } from './ProcesHandlerHelpers';
import { StringHelpers } from '../../helpers/StringHelpers';
import { FormService, AnimationService } from '../../services';
import { Step } from '../../models/Step';
import { memorySizeOf } from '../../utils/MemorySize';
import { MAX_POSTDATA_SIZE } from '../../constants/Constants';
import { getAllUrlParams } from '../../../jslibs/urlparams';
import { IFormFieldDefinition } from '../../interfaces/Fields';
import { reformatUrlRelativePaths } from '@fnv-core/utils';

export class ReactFormHelpers {

  static getFormValuesToStore(component: FormControllerContainer, values: any) {
    let formDefinition: Array<any> =
      component.props.formDefinitions[(component.state as any).currentForm];
    const valuesToStore = {};

    formDefinition.map((formFieldDefinition: any) => {

      if (formFieldDefinition['type'] == 'text') {
        if (formFieldDefinition.allowPrefixSpacesInInputOnly === true) {
          valuesToStore[formFieldDefinition.name] = (values[
            formFieldDefinition.name
          ] || "").replace(/^\s+/, '');
        }
      }
    });

    return valuesToStore;
  }

  static gotoFormStepNyName(component: FormControllerContainer, formName) {
    const stepIndex = component.props.formConfig.formSteps.indexOf(formName);
    if (stepIndex < component.props.formConfig.formSteps.length) {
      var formName: any = component.props.formConfig.formSteps[stepIndex];
      component.props.setActiveStepForm(formName);

      component.setState(
        {
          stepIndex: stepIndex,
          currentForm: formName
        },
        () => {
          component.scrollToForm();
        }
      );
    }
  }

  static continuewithGotoNextStep(component: FormControllerContainer, nextStep: number, onlySaveForm?: boolean) {

    if (!!onlySaveForm) {
      component.setState({
        isSubmitting: false
      });
    } else {
      const formName: any = component.props.formConfig.formSteps[nextStep];
      component.props.setActiveStepForm(formName);
      component.setState(
        {
          stepIndex: nextStep,
          currentForm: formName,
        },
        () => {
          component.scrollToForm();
        }
      );
    }
  }

  static gotoNextFormStep(component: FormControllerContainer, values: any[],
    includeCurrentValues?: boolean,
    onlySaveForm?: boolean) {
    if (!!onlySaveForm) {
      component.setState({ isSubmitting: true });
      ReactFormHelpers.postToBackendPopup(component, values, true, true).then(() => {
        ReactFormHelpers.continuewithGotoNextStep(component, component.state.stepIndex, true);
      }).catch(() => {
        ReactFormHelpers.continuewithGotoNextStep(component, component.state.stepIndex, true);
      });
      return;
    }
    const nextStep = component.state.stepIndex + 1;
    if (nextStep < component.props.formConfig.formSteps.length) {
      if (!!component.props.formConfig.postOnNextAndPreviousStep) {
        ReactFormHelpers.postToBackendPopup(component, values, true, true).then(() => {
          ReactFormHelpers.continuewithGotoNextStep(component, nextStep);
        }).catch(() => {
          ReactFormHelpers.continuewithGotoNextStep(component, nextStep);
        });
      } else
        if (component.props.formConfig.postUrlForFirstStep !== undefined &&
          component.props.formConfig.postUrlForFirstStep !== "" &&
          component.state.stepIndex === 0) {
          ReactFormHelpers.postToBackendPopup(component, values, true, true).then(() => {
            ReactFormHelpers.continuewithGotoNextStep(component, nextStep);
          }).catch(() => {
            ReactFormHelpers.continuewithGotoNextStep(component, nextStep);
          });
        } else {
          ReactFormHelpers.continuewithGotoNextStep(component, nextStep);
        }

    } else {
      component.setState({ isSubmitting: true });

      $(window).off('beforeunload');

      if (component.props.formConfig.actionUrl) {
        let queryParameters = [];
        for (let key in values) {
          let value = values[key];
          if (value) {
            queryParameters.push(`${key}=${value}`);
          }
        }
        if (typeof component.state.urlParams['broncode']) {
          queryParameters.push(`broncode=${component.state.urlParams['broncode']}`);
        }
        location.href =
          component.props.formConfig.actionUrl + '?' + queryParameters.join('&');
      } else {
        if (component.props.formConfig.popupConfirm === true) {
          component.setState({ showPopupConfirm: true });
        } else {
          component.onPostToBackend(values, !!includeCurrentValues);
        }
      }
    }
  }

  static isReadOnly(component: FormControllerContainer) {
    return component.props.editMode !== true || component.props.formConfig.readOnly === true;
  }

  static getPageSettings(component: FormControllerContainer, formName: string) {
    return component.props.formConfig.pageSettings[formName];
  }

  static activateFormController(component: FormControllerContainer) {

    component.props.clearFormErrorMessage(component.state.currentForm);
    let pathParam = component.context.pathParam || "";
    if (component.context && component.context.search) {
      const urlParams = getAllUrlParams(component.context.search);
      if (urlParams["additionalId"]) {
        pathParam = urlParams["additionalId"];
      }
      // dont use location.href for url parameters here, because they
      // will be passed on with subsequent requests within mijn-fnv            
    }

    if (component.props.formConfig.fillViaApi) {
      component.props.fillFormViaApi(
        component.state.currentForm,
        component.props.userId,
        component.props.formConfig.fillViaApi,
        component.props.formDefinitions,
        pathParam,
        component.props.formConfig.formSteps,
        component.props.formConfig,
        component.props.formName
      );
    } else {
      if (component.props.initialData !== undefined) {
        component.props.setFormValues(component.state.currentForm, component.props.initialData);
      } else {
        component.props.setFormValues(component.state.currentForm, {});
      }
    }

    component.props.clearStep();
    component.props.clearExtraStep();

    if (component.props.formConfig.extraDummySteps) {
      component.props.formConfig.extraDummySteps.map(step => {
        component.props.storeExtraStep(step);
      });
    }
    component.props.formConfig.formSteps.map(step => {
      component.props.storeStep(this.getPageSettings(component, step).title || step, step);
    });

    if (component.props.formConfig.formSteps.length > 0) {
      component.props.setActiveStepForm(component.props.formConfig.startForm);
    }

    component.props.clearErrorOnApiError();
    component.scrollToForm();
  }

  static finishGotoPreviousStep(component: FormControllerContainer, values: any[]) {
    let formName: string =
      component.props.formConfig.formSteps[component.state.stepIndex - 1];
    component.props.setActiveStepForm(formName);

    component.setState(
      {
        stepIndex: component.state.stepIndex - 1,
        currentForm: formName
      },
      () => {
        component.scrollToForm();
      }
    );
  }

  static gotoPreviousStep(component: FormControllerContainer, values: any[]) {
    if (component.state.stepIndex > 0) {

      if (!!component.props.formConfig.postOnNextAndPreviousStep) {
        component.onStoreValues(values);
        ReactFormHelpers.postToBackendPopup(component, values, true, true).then(() => {
          ReactFormHelpers.finishGotoPreviousStep(component, values);
        }).catch(() => {
          ReactFormHelpers.finishGotoPreviousStep(component, values);
        });
      } else {
        ReactFormHelpers.finishGotoPreviousStep(component, values);
      }
    }
  }

  static getBaseFormProperties(component: FormControllerContainer) {
    const props = component.props;
    const state = component.state as any;
    const formproperties = {
      editMode: props.editMode !== undefined ? props.editMode : true,
      formConfig: props.formConfig,
      formDefinitions: state.formDefinitions,
      additionalCssClass: props.additionalCssClass,
      withLinkToFormPage: props.withLinkToFormPage,
      formName: props.formName,
      pageType: props.pageType
    };

    return formproperties;
  }

  static collectDataFromForms(component: React.Component<FormProps, FormState>) {
    const reactForms = component.props.forms;
    const formSteps = component.props.formConfig.formSteps;

    const formData = formSteps.reduce((postData: any, formStep: string) => {
      if (reactForms[formStep] !== undefined) {
        postData = (Object as any).assign(postData, reactForms[formStep]);
      }
      return postData;
    }, {});

    return formData;
  }

  static setFormValues(component: React.Component<FormProps, FormState>, data: any) {
    component.props.setFormValues(component.state.currentForm, data);
  }

  static getFormValues(component: React.Component<FormProps, FormState>) {
    return component.props.forms[component.state.currentForm] || {};
  }

  static getDefaultFormValues(component: React.Component<FormProps, FormState>) {
    const formDefinition = component.props.formDefinitions[component.state.currentForm];
    const defaultFormValues = {};
    if (formDefinition !== undefined) {
      formDefinition.forEach((field) => {
        if (field.defaultValue !== undefined && field.defaultValue !== "") {

          const value = StringHelpers.replacePropertiesInString(field.defaultValue, {
            CurrentRoleEnvironment: UserService.getCurrentRole()
          }, true);

          defaultFormValues[field.name] = value;
        }
      });
    }
    return defaultFormValues;
  }

  static setInitialFormValues(component: React.Component<FormProps, FormState>, data: any) {
    component.setState({ initialFormValues: data });
  }

  static getInitialFormValues(component: React.Component<FormProps, FormState>) {
    return component.state.initialFormValues || {};
  }

  static addToUrl(component: React.Component<FormProps, FormState>) {
    const props = component.props as any;
    let addToUrl = '';
    let addToUrls = [];
    let postDataToBackend = (Object as any).assign({}, props.forms);
    if (component.state.urlParams['broncode']) {
      postDataToBackend['broncode'] = component.state.urlParams['broncode'];
      addToUrls.push(`broncode=${component.state.urlParams['broncode']}`);
    }

    if (props.formConfig.thanksPageUrlFields) {
      addToUrls = [
        ...addToUrls,
        ...props.formConfig.thanksPageUrlFields.map((fieldItem: any) => {
          if (fieldItem.isReturnedBasedOnPostResult === true) {
            return;
          }
          if (fieldItem.urlField) {
            return `${fieldItem.urlField}=${props.forms[fieldItem.form][fieldItem.field]}`;
          }
          return `${fieldItem.field}=${props.forms[fieldItem.form][fieldItem.field]}`;
        }).filter((fieldItem) => fieldItem)
      ];
    }

    if (addToUrls.length) {
      addToUrl = '?' + addToUrls.join('&');
    }

    return { addToUrl, postDataToBackend };
  }

  static addQueryParamsBasedOnPostResult(component: React.Component<FormProps, FormState>, data: any) {
    const props = component.props as any;
    let addToUrls = [];

    if (props.formConfig.thanksPageUrlFields) {
      addToUrls = [
        ...props.formConfig.thanksPageUrlFields.map((fieldItem: any) => {
          if (fieldItem.isReturnedBasedOnPostResult === true) {
            return `${fieldItem.field}=${data[fieldItem.field]}`;
          }
          return;
        }).filter((fieldItem) => fieldItem)
      ];
    }

    return addToUrls.join('&');
  }

  static activateForm(component: React.Component<FormProps, FormState>) {
    const formConfig = component.props.formConfig;
    const handleProces = ProcesHandlerHelpers.handleProces;
    component.props.clearFormErrorMessage(component.props.formName);
    handleProces(formConfig.handlers, ProcesName.Init_done, component, {});
  }

  static createFormData(postData: { [key: string]: any }) {
    let formData = new FormData();
    for (var property in postData) {
      if (postData.hasOwnProperty(property)) {
        formData.append(property, postData[property]);
      }
    }
    return formData;
  }

  /**
   * Formats the given values to the format it should be as value.
   * @param value The value to format.
   * @param formDef The formfield definition to use.
   * @returns The value as it should be send to the backend.
   */
  static getValueForFormDefinition(value, formDef: IFormFieldDefinition) {
    let result = value;

    // Date objects
    if (formDef.dataType === "date") {
      let date = Moment(result, "DD-MM-YYYY", true);
      if (date.isValid()) {
        result = date.format("YYYY-MM-DD");
      } else {
        date = Moment(result, "YYYY-MM-DDTHH:mm:ss", true);
        if (date.isValid()) {
          result = date.format("YYYY-MM-DD");
        }
      }
    }
    // Booleans
    else if (formDef.type === "checkbox" && formDef.dataType === "boolean") {
      result = (result === true || result == "true");
    }
    // Numbers
    else if (!!formDef.isNumeric) {
      if (!!formDef.allowDecimals && !!value) {
        result = value.replace(/,/, '.');
      }
    }
    // Arrays
    else if (formDef.dataType === 'array' && Array.isArray(value)) {
      const valueField = formDef.valueField || 'value';
      result = value.map(val => {
        if (typeof val === 'string') {
          return val;
        }
        return val[valueField] || val.value;
      }).join(formDef.separator || ',');
    }

    return result;
  }

  /**
   * Rewrites the data to post to the format it should be sended.
   * @example
   * Dropdowns are stored in state as objects with the labels, values etcetera, but only the values should be send to the backend.
   * @param postData The postdata to reformat.
   * @param formDefinitions The form field definitions.
   * @param formSteps The form steps.
   * @returns The postdata formatted as it should be send to the backend.
   */
  static rewriteValueObjectsInPostData(postData: { [key: string]: any }, formDefinitions: { [key: string]: any[] }, formSteps: string[]) {
    for (const property in postData) {
      if (postData.hasOwnProperty(property)) {
        let rewrittenFieldValue = postData[property];
        if (rewrittenFieldValue &&
          rewrittenFieldValue.value !== undefined) {

          // rewrite dropdown value/label object to value directly
          rewrittenFieldValue = rewrittenFieldValue.value;
        }

        // rewrite specific types to its correct representation which is needed in the backend
        // Use the 'every' method to be able to break out without enumerating unneeded values
        formSteps.every(formStepName => {
          const formFieldDefinition = formDefinitions[formStepName].find((formFieldDefinition) => formFieldDefinition.name === property);
          if (formFieldDefinition) {
            rewrittenFieldValue = ReactFormHelpers.getValueForFormDefinition(rewrittenFieldValue, formFieldDefinition);
            // Field has been found, return false to break out of the 'every' enumerator
            return false;
          }
        });

        postData[property] = rewrittenFieldValue;
      }
    }

    return postData;
  }

  static hasFileUploadField(formDefinitions, formSteps) {
    let result = false;
    formSteps.map((formName) => {
      formDefinitions[formName].map((formFieldDefinition: any) => {
        if (formFieldDefinition.type == "fileupload") {
          result = true;
        }
      });
    });
    return result;
  }

  static clearFormIfAllowed(component: React.Component<FormProps, FormState>) {
    if (component.props.formConfig.clearFormAfterPost) {
      try {
        component.props.clearFormValues(component.props.formName);
        if (component.props.steps) {
          component.props.steps.steps.map((step: Step) => {
            if (step.formName !== component.props.formName && step.formName !== "_summary") {
              component.props.clearFormValues(step.formName);
            }
          });
        }
      } catch (err) {
        // tslint:disable-next-line
        console.log("error after clear forms", err);
      }
    }
  }

  static isPostDataToBig(postData) {
    return memorySizeOf(postData) > MAX_POSTDATA_SIZE;
  }

  static handleActionUrl = (postData) => {
    let reactRootElement = document.getElementsByClassName("react-container");
    if (reactRootElement.length > 0) {
      if (reactRootElement[0].hasAttribute("data-action-url")) {

        const url = reactRootElement[0].getAttribute("data-action-url");
        if (url != "") {
          let queryParameters = "";
          for (let key in postData) {
            let value = postData[key];
            if (value != "") {
              queryParameters += key + "=" + value + "&";
            }
          }
          let queryParamsSeparator = "?";
          let urlParams = getAllUrlParams(url);
          for (let urlParam in urlParams) {
            if (urlParams.hasOwnProperty(urlParam)) {
              queryParamsSeparator = "&";
            }
          }
          location.href = url + queryParamsSeparator + queryParameters;
          return true;
        }

      }
    }
    return false;
  }

  static postToBackendPopup(component: React.Component<FormProps, FormState>, values: any[], includeCurrentValues: boolean = false, isOnlySaveForm: boolean = false) {

    return new Promise((resolve, reject) => {

      try {

        const props = component.props as any;

        AnimationService.disableAnimationsForForm(component.state.currentForm);

        let handlers = component.props.formConfig.handlers;
        if (!handlers) {
          handlers = ProcesHandlerHelpers.getProcessesForHander(component.props.formConfig.procesHandlers);
        }
        const p_preProcess = ProcesName.Put_preprocess;
        const p_success = ProcesName.Put_postprocess_Success;
        const p_failure = ProcesName.Put_postprocess_Fail;
        const handleProces = ProcesHandlerHelpers.handleProces;

        const { addToUrl, postDataToBackend } = this.addToUrl(component);
        let doFormMultipartPost = ReactFormHelpers.hasFileUploadField(props.formDefinitions, props.formConfig.formSteps);
        if (component.props.formConfig.doFormMultipartPost !== undefined) {
          doFormMultipartPost = component.props.formConfig.doFormMultipartPost;
        }
        let httpMethod: string = 'put';

        if (
          component.props.formConfig.postPutMethod !== undefined &&
          component.props.formConfig.postPutMethod !== ''
        ) {
          httpMethod = component.props.formConfig.postPutMethod;
        }

        let postData = {};

        // includePayloadInPost
        if ((!!component.props.formConfig.includePayloadInPost) && (component as any).getPayload) {
          postData = {
            ...(component as any).getPayload()
          };
        }
        props.formConfig.formSteps.map(function (form: string) {
          if (postDataToBackend[form] !== undefined) {
            postData = (Object as any).assign({}, postData, postDataToBackend[form]);
          }
        });

        if (!!includeCurrentValues && values) {
          postData = (Object as any).assign({}, postData, values);
        }

        // "broncode" een heel specifiek iets van het FNV lid-worden formulier
        // het wordt via de url doorgegeven als query parameter
        // het is feitelijk een campagne-code en moet doorgegeven worden aan esb/crm.
        // op het lid-worden form is het een onzichtbaar veld
        // TODO : zoeken naar een generieke oplossing waar niet deze hack voor nodig is
        if (component.context.bronCode || (window as any).WordLidBroncode) {
          postData["BronCode"] = component.context.bronCode || (window as any).WordLidBroncode || "";
        }

        if (ReactFormHelpers.handleActionUrl(postData)) {
          return;
        }

        postData = ReactFormHelpers.rewriteValueObjectsInPostData(postData, props.formDefinitions, props.formConfig.formSteps);
        postData["Invoeromgeving"] = UserService.getCurrentRole();

        let postUrl: string = props.formConfig.postUrl;
        if (props.formConfig.postUrlForFirstStep !== undefined &&
          props.formConfig.postUrlForFirstStep !== "") {
          if (component.state.stepIndex === 0) {
            postUrl = props.formConfig.postUrlForFirstStep;

            if (!!props.formConfig.doFormMultipartPostForFirstStep) {
              doFormMultipartPost = true;
            }
          }
        }

        let idForUrl = component.props.userId;
        if (component.context.pathParam) {
          idForUrl = component.context.pathParam;
        }

        const urlParams = getAllUrlParams(component.context.search);
        if (urlParams["additionalId"]) {
          idForUrl = urlParams["additionalId"];
        }

        postUrl = Tokenizer.replaceTokens(postUrl, [idForUrl]);
        postUrl = Tokenizer.replaceTokens(postUrl, [{ name: 'formname', value: component.props.formName.toLowerCase() }]);

        if (!!isOnlySaveForm) {
          const params = getAllUrlParams(postUrl);
          let hasParams = false;
          for (let urlParam in params) {
            if (params.hasOwnProperty(urlParam)) {
              hasParams = true;
            }
          }
          if (hasParams) {
            postUrl += "&saveIncompleteForm=true";
          } else {
            postUrl += "?saveIncompleteForm=true";
          }
        }

        let addQueryParameterSeparator = "?";
        if (postUrl.indexOf("?") >= 0) {
          addQueryParameterSeparator = "&";
        }
        if (urlParams["KenticoWordLidId"]) {
          postUrl = `${postUrl}${addQueryParameterSeparator}KenticoWordLidId=${urlParams["KenticoWordLidId"]}`;
        }

        if (!!(component.props.formConfig as any).replaceUrlVariablesWithFormData) {
          postUrl = StringHelpers.replacePropertiesInUrl(postUrl, postData, true);
        }

        if (component.props.formConfig.useModuleForFormPost) {
          import('../../modules/' + component.props.formConfig.useModuleForFormPost).then(module => {
            try {
              const postToModule = new module.Module();
              postToModule.post(postData, props.formConfig.thanksPageUrl);
            } catch (err) {
              component.props.storeFormErrorMessage(component.state.currentForm, err);
              component.setState({
                isSubmitting: false
              });
              return;
            }
          });

          return;
        }
        if (component.props.formConfig.skipPost) {
          if (props.formConfig.thanksPageUrl &&
            props.formConfig.thanksPageUrl !== "") {
            ReactFormHelpers.clearFormIfAllowed(component);
            location.href = props.formConfig.thanksPageUrl + addToUrl;
            return;
          }

          (component as any).onPopupOKSubmit(undefined,
            StringHelpers.replacePropertiesInUrl(props.formConfig.reactRouteOnSuccess || "",
              {
                ...(component as any).getPayload(),
                ...postData
              }, true)
          );
          return;
        }

        if (ReactFormHelpers.isPostDataToBig(postData)) {
          component.setState({
            isShowTooBigDataError: true,
            isSubmitting: false
          });
          return;
        }

        handleProces(handlers, p_preProcess, component, postData).then(
          _postData => {
            postUrl = reformatUrlRelativePaths(postUrl);
            let ajaxOptions;
            if (doFormMultipartPost) {
              ajaxOptions = {
                type: httpMethod,
                contentType: false,
                enctype: 'multipart/form-data',
                data: ReactFormHelpers.createFormData(_postData),
                processData: false,
                url: postUrl
              };
            } else {
              ajaxOptions = {
                type: httpMethod,
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(_postData),
                url: postUrl
              };
            }

            // Url referrer headers might be blocked by firewalls, so send a custom one to use
            // to know which page is viewed currently
            ajaxOptions.headers = {
              'X-Current-Path': window.location.pathname,
            };

            $.ajax(ajaxOptions)
              .done(receivedData => {

                if (!!isOnlySaveForm) {
                  resolve(undefined);
                  return true;
                }

                $(window).off('beforeunload');
                handleProces(handlers, p_success, component, receivedData)
                                    /*Process*/.then(data => {
                  // clearForm depending on formconfig and if the ok-popup needs to be shown...
                  // clear it after the user pressed ok (otherwise the summary is already cleared)
                  if (data.isPreventDefault === true) {
                    ReactFormHelpers.clearFormIfAllowed(component);
                    resolve(undefined);
                    return;
                  }
                  if (data.isShowPostDataError === true) {

                    component.setState({
                      isSubmitting: false
                    });

                    ReactFormHelpers.clearFormIfAllowed(component);
                    resolve(undefined);
                    return;
                  }

                  if (receivedData
                    && receivedData.RedirectUrl !== undefined
                    && receivedData.RedirectUrl !== null
                    && receivedData.RedirectUrl !== "") {
                    if(receivedData.Target === "_blank") {
                      window.open(receivedData.RedirectUrl, receivedData.target);
                      location.reload();
                    }
                    else {
                      location.href = receivedData.RedirectUrl;
                    }
                    resolve(undefined);
                    return;
                  }

                  if (receivedData && !!receivedData.HasError &&
                    receivedData.ErrorText !== undefined &&
                    receivedData.ErrorText !== "") {
                    component.setState({
                      isSubmitting: false,
                      isShowPostDataError: true,
                      popupMessageOnFailure: receivedData.ErrorText
                    });
                    resolve(undefined);
                    return;
                  }

                  if (!!component.props.formConfig.showPollResultsAfterFormSubmit) {
                    (component as any).onShowPollResults();
                    return;
                  }

                  if (component.props.formConfig.reactRouteOnFailure === "" &&
                    props.formConfig.thanksPageUrl &&
                    props.formConfig.thanksPageUrl !== "") {

                    let queryParams = "";
                    if (typeof receivedData === "string") {
                      try {
                        const json = JSON.parse(receivedData);
                        queryParams = this.addQueryParamsBasedOnPostResult(component, json);
                        if (addToUrl !== "") {
                          if (addToUrl !== "?") {
                            queryParams = "&" + queryParams;
                          }
                        } else {
                          queryParams = "?" + queryParams;
                        }
                      } catch (err) {
                        // tslint:disable-next-line
                        console.log("postToBackendPopup json parsing error", receivedData, err);
                      }
                    }
                    ReactFormHelpers.clearFormIfAllowed(component);
                    location.href = `${props.formConfig.thanksPageUrl}${addToUrl}${queryParams}`;
                    resolve(undefined);
                    return;
                  }


                  if (
                    props.formConfig.popupOK === undefined ||
                    props.formConfig.popupOK === true
                  ) {
                    // receivedData.VerwerkingsCode == 0 : Visuelecontrole
                    // receivedData.VerwerkingsCode == 1 : AutomatischVerwerken
                    if (receivedData.VerwerkingsCode === 0) {
                      component.setState({ isShowPostOk: true, isShowPostOKWithVisualCheck: true, showThanksMessageAsInPageContent: !!props.formConfig.showThanksMessageAsInPageContent });
                    } else {
                      component.setState({ isShowPostOk: true, showThanksMessageAsInPageContent: !!props.formConfig.showThanksMessageAsInPageContent }, () => {
                        if (!!props.formConfig.showThanksMessageAsInPageContent) {
                          if ((component as any).thankYouMessageRef &&
                            (component as any).thankYouMessageRef.current) {
                            (component as any).thankYouMessageRef.current.scrollIntoView();
                          }
                        }

                      });
                    }
                    resolve(undefined);
                    return;
                  }
                  (component as any).onPopupOKSubmit(undefined,
                    StringHelpers.replacePropertiesInUrl(props.formConfig.reactRouteOnSuccess || "",
                      {
                        ...(component as any).getPayload(),
                        ...postData
                      })
                  );

                })
                                    /*Process*/.catch(reason => {
                  location.href = props.formConfig.errorPageUrl + addToUrl;
                  reject();
                });
              })
              .fail(error => {
                component.setState({
                  isSubmitting: false
                });

                if (!!isOnlySaveForm) {
                  reject();
                  return true;
                }

                handleProces(handlers, p_failure, component, error)
                                    /*Process*/.then(data => {
                  if (data && data.isError) {
                    if (ReactFormHelpers.handleUserError(data, component)) {
                      reject();
                    } else {
                      component.setState({
                        isShowPostDataError: true

                      });
                      reject();
                    }
                  } else
                    if (component.props.formConfig.reactRouteOnFailure !== undefined &&
                      component.props.formConfig.reactRouteOnFailure !== "") {
                      component.setState({
                        isShowPostDataError: true

                      });
                      reject();
                    } else {
                      location.href = props.formConfig.errorPageUrl + addToUrl;
                      reject();
                    }
                })
                                    /*Process*/.catch(reason => {
                  location.href = props.formConfig.errorPageUrl + addToUrl;
                  reject();
                });
              });
          }
        );
      } catch (err) {
        // tslint:disable-next-line
        console.log("exception in postToBackendPopup", err);
        reject();
      }
    });
  }

  static handleUserError(dataError: any, formContainer: any) {
    if (dataError && dataError.ErrorText !== undefined) {
      try {
        let error = JSON.parse(dataError.ErrorText);
        if(error.ControlName != null) {
          formContainer.setFieldError(error.ControlName, error.ErrorText)
          return true;
        }

        formContainer.setState({
          isShowPostDataError: true,
          isSubmitting: false,
          isUserError: !!error.IsUserError,
          popupMessageOnFailure: error.ErrorText || ""
        });
        return true;
      } catch {
        // skip
      }
      return false;
    }
  }
  static hasLidConsentForSpecificFormsOrIgnoreIfIsCurrentUser(component: React.Component<FormProps, FormState>): boolean {
    const checkForms = [
      "MijnFNVConsulent_Gespreksregistratie",
      "MijnFNVConsulent_AanvraagReintegratieconsulent",
      "MijnFNVConsulent_IntakeArbeid",
      "MijnFNVConsulent_IntakeOntslag",
      "MijnFNVConsulent_IntakePensioen",
      "MijnFNVConsulent_IntakeUitkering",
      "MijnFNV_KeuzeVolgendeStap",
      "MijnFNV_GespreksregistratieOverzicht",
      "MijnFNV_DossierOverzicht",
      "MijnFNV_ContactGegevens",
      "MijnFNV_Inkomensgegevens"
    ];

    const checkFormsAllowEmptyPathParm = [
      "MijnFNV_DossierOverzicht",
      "MijnFNV_ContactGegevens",
      "MijnFNV_Inkomensgegevens"
    ];

    const ignoreClearLidZoekenSubFunctons = [
      "MijnFNV_LidZoeken",
      "MijnFNV_LidGevonden"
    ];

    const ignorePaths = [
      "Mijn-FNV/Medewerker/Persoon/Persoon-profiel"
    ];

    for (let i = 0; i < ignorePaths.length; i++) {
      const entry = ignorePaths[i];
      if (component.context !== undefined && component.context.pathname !== undefined) {
        if (component.context.pathname.indexOf(entry) > -1) {
          return true;
        }
      }
    }

    if (ignoreClearLidZoekenSubFunctons.indexOf((component.props.formName || "").split("-")[0]) < 0) {
      FormService.setIsInLidZoekenSubFunctions(false);
    }

    if (checkForms.indexOf(component.props.formName || "") >= 0) {

      if (!component.context.pathParam &&
        checkFormsAllowEmptyPathParm.indexOf(component.props.formName || "") >= 0) {
        FormService.setIsInLidZoekenSubFunctions(true);
        return true;
      } else
        if (component.context.pathParam === UserService.getUserId()) {
          FormService.setIsInLidZoekenSubFunctions(true);
          return true;
        } else
          if (component.context.pathParam &&
            component.props.lidZoeken &&
            component.props.lidZoeken.results) {
            const lidGevonden = component.props.lidZoeken.results.filter((lid) => {
              return (lid.PersoonsId === component.context.pathParam && lid.LidgaatAkkoord === true);
            });
            const isLidGevonden = lidGevonden.length > 0;

            FormService.setLidZoekenSubFunctionsForMember({});
            if (isLidGevonden) {
              FormService.setLidZoekenSubFunctionsForMember({
                memberName: lidGevonden[0].Naam,
                isMember: lidGevonden[0].IsLid
              });
              FormService.setIsInLidZoekenSubFunctions(true);
            }

            return isLidGevonden;
          }
      return false;
    }
    return true;
  }
}
